import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { useNavigate, useRouteError } from 'react-router';
import { Text, Logo, Button, theme } from '@socrait/react';

import NotFoundImageUrl from '~/assets/images/error_image.png';

function makeErrorProps(error?: unknown) {
  if (error && error instanceof Error) {
    return {
      header: 'Oops!',
      text: `Something's not quite right.`,
      errorCode: `ERROR 500: ${error.message}`,
    };
  } else {
    return {
      header: 'Oops!',
      text: "It looks like we can't find what you're looking for.",
      errorCode: 'ERROR 404',
    };
  }
}

export function ErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const errorProps = makeErrorProps(error);

  return (
    <View style={styles.container}>
      <View style={styles.logo}>
        <Logo width={40} height={40} />
      </View>
      <Text style={styles.title}>{errorProps.header}</Text>
      <Text style={styles.subtitle}>{errorProps.text}</Text>
      <Text style={styles.errorCode}>{errorProps.errorCode}</Text>
      <Button variant="primary" name="Go Back" onPress={() => navigate(-1)} />
      <img style={styles.image} src={NotFoundImageUrl} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.xlarge,
    padding: theme.spacing.xlarge * 2,
  },
  logo: {
    position: 'absolute',
    top: theme.spacing.xlarge * 2,
    left: theme.spacing.xlarge * 2,
    width: 40,
    height: 40,
  },
  title: {
    fontSize: theme.fontSizes.large * 2,
    fontWeight: theme.fontWeights.bold,
    textAlign: 'center',
    marginTop: theme.spacing.xlarge * 4,
  },
  subtitle: {
    fontSize: theme.fontSizes.medium,
    textAlign: 'center',
  },
  errorCode: {
    fontSize: theme.fontSizes.xmedium,
    fontWeight: theme.fontWeights.bold,
    marginBottom: theme.spacing.xlarge,
  },
  image: {
    position: 'absolute',
    bottom: 0,
    width: '75%',
    height: 'auto',
    maxWidth: 900,
    zIndex: -1,
  },
});
